import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function ConsumoTeoricoPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="analisis"
      subsectionPath="consumo-teorico"
    />
  );
}
